// extracted by mini-css-extract-plugin
module.exports = {"changeLog":"changeLog_changeLog__3avPY","loading":"changeLog_loading__2vVO0","error":"changeLog_error__3PaIb"};